

export enum MENU_ADDONS {
  ADDON_APPLICATION_NOTICE = 'ADDON_APPLICATION_NOTICE',
  ADDON_EMAIL_NOTICE = 'ADDON_EMAIL_NOTICE',
  ADDON_LINE_NOTIFY = 'ADDON_LINE_NOTIFY',
  ADDON_FORM_RETRIEVE = 'ADDON_FORM_RETRIEVE',
  // ADDON_DOCTOR_NOTE = 'ADDON_DOCTOR_NOTE',
  ADDON_DOCTOR_NOTE = 'DOCTOR_NOTE',
  ADDON_HOME = 'HOME',
  ADDON_DASHBOARD = 'DASHBOARD',
  ADDON_REGISTER_APP = 'REGISTER_APP',
  ADDON_EXTRA = 'EXTRA',
  ADDON_BANNER = 'BANNER',
  ADDON_ABOUT_US = 'ABOUT_US',
  ADDON_SERVICE = 'SERVICE',
  ADDON_PRICE_LIST = 'PRICE_LIST',
  ADDON_REVIEW = 'REVIEW',
  ADDON_ARTICLE = 'ARTICLE',
  ADDON_CONTACT_US = 'CONTACT_US',
  ADDON_PROMOTIONS = 'PROMOTIONS',
  ADDON_NEWS = 'NEWS',
  ADDON_RETROSPECTIVE_ORDER = 'RETROSPECTIVE_ORDER',
  ADDON_RETROSPECTIVE_EDIT = 'RETROSPECTIVE_EDIT',
  ADDON_WAREHOUSES = 'WAREHOUSES',

  ADDON_TREATMENT_TEMPLATE = 'ADDON_TREATMENT_TEMPLATE',
  ADDON_TREATMENT_TEMPLATE_TYPE = 'ADDON_TREATMENT_TEMPLATE_TYPE',

  ADDON_TREATMENT_PLAN_MANAGE = 'TREATMENT_PLAN_MANAGE',
  ADDON_TREATMENT_PLAN_TYPE = 'TREATMENT_PLAN_TYPE',
  ADDON_TREATMENT_PLAN = 'TREATMENT_PLAN',

  ADDON_TREATMENT_COURSE_MANAGE = 'TREATMENT_COURSE_MANAGE',
  ADDON_TREATMENT_COURSE_TYPE = 'TREATMENT_COURSE_TYPE',
  ADDON_TREATMENT_COURSE = 'TREATMENT_COURSE',

  ADDON_DOCTOR_NOTE_TYPE_FORM = 'DOCTOR_NOTE_TYPE_FORM',
  ADDON_DOCTOR_NOTE_FORM = 'DOCTOR_NOTE_FORM',
  ADDON_DOCTOR_NOTE_TYPE_PIC = 'DOCTOR_NOTE_TYPE_PIC',
  ADDON_DOCTOR_NOTE_PIC = 'DOCTOR_NOTE_PIC',
  ADDON_PRODUCTS = 'PRODUCTS',

  /** v2 Ultra  */
  ADDON_RECALL = 'RECALL',
  ADDON_RECALL_LIST = 'RECALL_LISTS',
  ADDON_INSTALLMENT = 'INSTALLMENT',
  ADDON_LAB = 'LAB',
  ADDON_LAB_MANAGEMENT = 'LAB_MANAGEMENT',
  ADDON_LAB_LIST = 'LAB_LIST',
  ADDON_LAB_TYPE = 'LAB_TYPE',
  ADDON_LAB_GROUP = 'LAB_GROUP',
  ADDON_LAB_COMPANY = 'LAB_COMPANY',
  ADDON_X_RAY = 'X_RAY',
  ADDON_XRAY_FILM_TYPE = 'XRAY_FILM_TYPE',
  ADDON_IMAGE_TYPE = 'IMAGE_TYPE',

  ADDON_SALARY = 'SALARY',
  ADDON_INCOME_EXPENSES = 'INCOME_EXPENSES',
  ADDON_ADVANCE = 'ADVANCE',

  ADDON_SETING_DOCTOR_NOTE = 'DOCTOR_NOTE',
  ADDON_WEB_MANAGE = "WEB_MANAGE",

  ADDON_APPROVELIST = "USAGE_APPROVAL_MANAGEMENT",
  ADDON_DEFAULT_PRODUCT = 'DEFAULT_PRODUCT',

  ADDON_FOLLOWUP = "FOLLOW_UP",

  /** จัดการชั้นของหน้าสาขา */
  ADDON_BRANCH_PAGE_LAYER = 'BRANCH_PAGE_LAYER'
}

